import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material";

export const SpacerStyles = makeStyles((theme: Theme) => ({
    root: {
        flexGrow: 1,
    }
}));
